/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyDetailBoardController', DinghyDetailBoardController);

    DinghyDetailBoardController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'DinghyBoard', 'Principal'];

    function DinghyDetailBoardController ($timeout, $scope, $state, $stateParams, entity, DinghyBoard, Principal) {
        var vm = this;

        vm.dinghy = entity;
        vm.wasActive = vm.dinghy.active;
        vm.dinghyName = vm.dinghy.name;
        $scope.currentObj.name = vm.dinghy.name;
        vm.save = save;
        vm.clear = clear;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $state.go('board.dinghy.dinghy');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dinghy.id !== null) {
                DinghyBoard.update(vm.dinghy, onSaveSuccess, onSaveError);
            } else {
                DinghyBoard.save(vm.dinghy, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:dinghyUpdate', result);
            // console.log(result.id);
            $state.go('board.dinghy.dinghy.edit', {id: result.id}, { reload: 'board.dinghy.dinghy' });
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        // summernote editor config
        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

    }
})();
